//预发布环境
const baseUrl = "http://pre.esopcms.qingkesec.com";
const appBaseUrl = "http://pre.esop.qingkesec.com";
const appQkzqBaseUrl = "http://pre.qkzq.qingkesec.com";
module.exports = {
  baseApi: `${baseUrl}/api`, // 测试api请求地址
  appBaseUrl: `${appBaseUrl}/api`,
  appQkzqBaseUrl: `${appQkzqBaseUrl}/api`,
};
